module.exports = __webpack_public_path__ + "img/TR.04e85c64.png";